import { dataCalendarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCalendarSolid = /*#__PURE__*/createIcon(dataCalendarSolid)
export default IconCalendarSolid
